'use client';

import { ForgotPassword } from "@stackframe/stack";
import Link from "next/link";

export default function ForgotPasswordPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-[#1E4289] mb-2">
            Forgot Password
          </h1>
          <p className="text-slate-600">
            Enter your email to reset your password
          </p>
        </div>
        <div className="bg-white border border-slate-200 rounded-lg shadow-sm p-8">
          <ForgotPassword />
        </div>
        <div className="text-center mt-6">
          <Link 
            href="/auth/signin" 
            className="text-[#1E4289] hover:underline text-sm"
          >
            ← Back to Sign In
          </Link>
        </div>
      </div>
    </div>
  );
}

